<template>
	<div>
		<q-btn-dropdown :label="full_name" :icon="getUserIcon" flat v-model="show_user_menu">
			<q-list link>
				<q-item @click.native="goToMessages()">
					<q-item-side>
						<q-icon name="far fa-envelope" size="1.5rem" />
					</q-item-side>
					<q-item-main>
						<q-item-tile label>{{ $t('messages') }}</q-item-tile>
					</q-item-main>
				</q-item>
				<q-item @click.native="goToProfile()" v-if="showUserProfile">
					<q-item-side>
						<q-icon name="fas fa-cog" size="1.5rem" />
					</q-item-side>
					<q-item-main>
						<q-item-tile label>{{ $t('edit_profile') }}</q-item-tile>
					</q-item-main>
				</q-item>
				<q-item @click.native="showChangePassword()">
					<q-item-side>
						<q-icon name="fas fa-key" size="1.5rem" />
					</q-item-side>
					<q-item-main>
						<q-item-tile label>{{ $t('change_password') }}</q-item-tile>
					</q-item-main>
				</q-item>
				<q-item-separator />
				<q-item @click.native="logout()">
					<q-item-side>
						<q-icon name="fas fa-sign-out-alt" size="1.5rem" />
					</q-item-side>
					<q-item-main>
						<q-item-tile label>{{ $t('sign_out') }}</q-item-tile>
					</q-item-main>
				</q-item>
			</q-list>
		</q-btn-dropdown>

		<change-password
			:show_change_password="show_change_password"
			@hide_modal="show_change_password = false"
		/>
	</div>
</template>

<script>
import ChangePassword from 'components/ChangePassword'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
export default {
	components: { 'change-password': ChangePassword },
	data() {
		return {
			show_user_menu: false,
			show_change_password: false,
		}
	},
	computed: {
		...mapGetters({
			full_name: 'common/full_name',
			access_token: 'common/access_token',
			user_module_items: 'common/user_module_items',
			id_user_client_selected: 'common/id_user_client_selected',
			clients: 'params/clients',
			is_superuser: 'common/is_superuser',
			user_change_password: 'common/user_change_password',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		showUserProfile() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					if (obj.has_profile) return true
				}
			}
			return false
		},

		getUserIcon() {
			if (this.is_superuser) return 'far fa-star'
			else return 'far fa-user'
		},
	},
	methods: {
		goToMessages() {
			this.show_user_menu = false
			this.$router.push({ name: 'messages' })
		},

		goToProfile() {
			this.show_user_menu = false
			this.$router.push({ name: 'profile_basic_data' })
		},

		showChangePassword() {
			this.show_user_menu = false
			this.show_change_password = true
		},

		logout() {
			this.show_user_menu = false
			this.$store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])

			firebase
				.auth()
				.signOut()
				.then(() => {})
				.catch((e) => {
					console.log(e)
				})

			setTimeout(() => {
				this.$q.loading.hide()
				this.$router.replace({ name: 'login' })
			}, 700)
		},

		getParams() {
			this.$axios
				.get('/clients/config/', this.getHeader)
				.then((response) => {
					this.$store.dispatch('params/SET_PARAMS', [
						response.data.login,
						response.data.clients,
						response.data.register,
						response.data.languages,
						response.data.qty_login_attempts,
						response.data.user_profile,
					])
					this.$store.dispatch('params/SET_PARAMS_LOADED', [true])

					if (this.$q.platform.is.cordova && this.app_version) {
						let app_version = process.env.APP_VERSION.split('.')
						let api_version = this.app_version.split('.')

						if (app_version[1] != api_version[1]) {
							this.logout()
						}
					}

					this.getUserDataUserSelection()
				})
				.catch((e) => {
					console.log(e)
				})
		},

		getUserDataUserSelection() {
			this.$axios
				.get('/accounts/read_user_data/', this.getHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},
	},
	created() {
		this.getParams()
	},
}
</script>

<style></style>
